<div class="app">
  <app-results-header page="become user" [isSubHidden]="true"></app-results-header>
  <div class="app-body" id="main" #main>
    <section
      class="app-center app-center--padded secondary-text-colour background-container-background"
    >
      <p>
        <app-light-toggle-group
          groupAriaLabel="User action selection"
          i18n-groupAriaLabel="@@userActionSelectionToggleGroupLabel"
        >
        </app-light-toggle-group>
      </p>
      @if (showType == 'become') {
        <div>
          <app-become-user></app-become-user>
        </div>
      }
    </section>
  </div>
</div>
